import { useLocation, useOutlet } from 'react-router-dom';
import './PageTransition.css';

function PageTransitionLayout() {
  const location = useLocation();
  const outlet = useOutlet();

  return (
    <div key={location.pathname} className="page-transition">
      {outlet}
    </div>
  );
}

export default PageTransitionLayout;
